<template>
  <div class="page" :class="{'page__has-bar': !readonly}">
    <div class="page__bd">
      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__hd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">单据编号</label>
            <em class="weui-form-preview__value">{{form.main.ra_code}}</em>
          </div>
        </div>
        <custom-layout class="weui-form-preview__bd" :view-config="customViewConfig">
          <div class="weui-form-preview__item" slot="ra_emname">
            <label class="weui-form-preview__label">{{customLabel.ra_emname || "申请人"}}</label>
            <span class="weui-form-preview__value weui-form-preview__value-icon">{{form.main.ra_emname}}
              <call-mobile :em-id="form.main.ra_emid"></call-mobile>
            </span>
          </div>
          <div class="weui-form-preview__item" slot="ra_department">
            <label class="weui-form-preview__label">{{customLabel.ra_department || "部门"}}</label>
            <span class="weui-form-preview__value">{{form.main.ra_department}}</span>
          </div>
          <div class="weui-form-preview__item" slot="ra_applydate">
            <label class="weui-form-preview__label">{{customLabel.ra_applydate || "申请日期"}}</label>
            <span class="weui-form-preview__value">{{form.main.ra_applydate}}</span>
          </div>
          <div class="weui-form-preview__item" slot="ra_position">
            <label class="weui-form-preview__label">{{customLabel.ra_position || "招聘岗位"}}</label>
            <span class="weui-form-preview__value">{{form.main.ra_position}}</span>
          </div>
          <div class="weui-form-preview__item" slot="ra_neednum">
            <label class="weui-form-preview__label">{{customLabel.ra_neednum || "需求人数"}}</label>
            <span class="weui-form-preview__value">{{form.main.ra_neednum}}</span>
          </div>
          <div class="weui-form-preview__item" slot="ra_time">
            <label class="weui-form-preview__label">{{customLabel.ra_time || "到岗日期"}}</label>
            <span class="weui-form-preview__value">{{form.main.ra_time}}</span>
          </div>
          <div class="weui-form-preview__item" style="text-align:left" slot="ra_duty">
            <h4>{{customLabel.ra_duty || "岗位职责"}}</h4>
            <div style="white-space: pre-line" v-html="form.main.ra_duty"></div>
          </div>
          <div class="weui-form-preview__item" style="text-align:left" slot="ra_require">
            <h4>{{customLabel.ra_require || "任职要求"}}</h4>
            <div style="white-space: pre-line" v-html="form.main.ra_require"></div>
          </div>
          <file-list v-model="form.main.ra_attach" slot="ra_attach"/>
        </custom-layout>
      </div>

      
    </div>

    <div class="footer-bar weui-dialog__ft" v-if="!readonly">
      <router-link
        :to="'/oa/recruit_edit?id='+form.main.id"
        v-if="editable"
        class="weui-dialog__btn weui-dialog__btn_primary"
      >编辑</router-link>
      <a
        href="javascript:;"
        v-if="editable"
        class="weui-dialog__btn weui-dialog__btn_primary"
        @click="f_audit"
      >审核</a>
      <a
        href="javascript:;"
        v-if="editable"
        class="weui-dialog__btn weui-dialog__btn_default"
        @click="p_remove"
      >删除</a>
      <a
        href="javascript:;"
        v-if="!editable"
        class="weui-dialog__btn weui-dialog__btn_default"
        @click="f_unaudit"
      >反审</a>
    </div>
  </div>
</template>

<script>
import CustomLayout from "@/components/layout/CustomLayout.vue";
import FileList from "@/components/FileList.vue";
import CallMobile from "@/components/button/CallMobile.vue";
import process from "@/mixins/process.js";

export default {
  mixins: [process],
  components: {
    CustomLayout,
    FileList,
    CallMobile
  },
  data() {
    return {
      baseUrl: "/api/oa/recruitapply",
      codeField: "ra_code",
      statusField: "ra_statuscode",
      caller: "RecruitApply",
      xtype: "oa-recruitapply-formpanel",
    };
  }
};
</script>